import { AppIcon } from '@/components/ui/icons/AppIcon'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const fallback = '/'

export const Route = createFileRoute('/_auth')({
  // https://tanstack.com/router/latest/docs/framework/react/examples/authenticated-routes?path=examples%2Freact%2Fauthenticated-routes%2Fsrc%2Froutes%2Flogin.tsx
  validateSearch: z.object({
    redirect: z.string().optional().catch(''),
  }),
  beforeLoad: ({ context, search }) => {
    if (context.auth.isAuthenticated) {
      throw redirect({ to: search.redirect || fallback })
    }
  },
  component: AuthLayout,
})

function AuthLayout() {
  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <a href="#" className="flex items-center gap-2 self-center font-medium">
          <AppIcon />
        </a>
        <Outlet />
      </div>
    </div>
  )
}
